import { Box, Text, Placeholder, HiddenFromView } from '@stitch-fix/mode-react';
import styles from './ProfilePhotos.module.scss';
const LoadingScreen = () => <Box className={styles.profilePhotosContainer}>
    <Text color="blue-45" align="center" mb={3}>
      <Placeholder width={20} height={4} />
    </Text>
    <Box display={{
    sm: 'block',
    lg: 'flex'
  }}>
      <Box className={styles.headshotSection}>
        <Box>
          <Placeholder variant="rect" height={20} width={20} mb={1} />
        </Box>
        <Box>
          <Placeholder variant="rect" height={8} width={20} mb={1} />
        </Box>
      </Box>
      <Box display={{
      sm: 'none',
      lg: 'block'
    }} width="2px" bgColor="gray-85" mx={1} />
      <Box className={styles.fullBodySection} mt={{
      sm: 3,
      lg: 0
    }}>
        <Box>
          <Placeholder variant="rect" height={20} width={20} mb={1} />
        </Box>
        <Box>
          <Placeholder variant="rect" height={8} width={20} mb={1} />
        </Box>
      </Box>
    </Box>
    <Placeholder height="80px" width={20} />
    <HiddenFromView>Loading...</HiddenFromView>
  </Box>;
export default LoadingScreen;